/** Ошибка предварительной загрузки Vite принадлежит конкретному rejected import */
const preloadFailures = new WeakSet<object>();
window.addEventListener('vite:preloadError', (event) => {
	const payload: unknown = (event as Event & { payload?: unknown }).payload;
	if (payload !== null && typeof payload === 'object') preloadFailures.add(payload);
});

/** React.lazy запоминает отказ: повтор рендера не загрузит новый chunk после выкатки */
export function needsImportReload(error: unknown): boolean {
	return (
		error instanceof Error &&
		(preloadFailures.has(error) ||
			/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed/i.test(
				error.message,
			))
	);
}
